import { render, staticRenderFns } from "./ReceiptIssueRecord.vue?vue&type=template&id=842909f0&scoped=true&"
import script from "./ReceiptIssueRecord.vue?vue&type=script&lang=js&"
export * from "./ReceiptIssueRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptIssueRecord.vue?vue&type=style&index=0&id=842909f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842909f0",
  null
  
)

export default component.exports